
import DpitColor from './DpitColor';
export default class DpitColorAnalyze {
	constructor(config) {
		if (config.dpDebugEn) console.log('[dpit] INIT DpitColorAnalyze');
	}
	// contrast range: 1 - 21
	static getContrastColor(srcColor, preferWhiteText = true, colorRangeArray = ['#fff', '#252525'], fallBackContrastThreshold = 3, fallbackColor = '#222') {
		const contrasts = [];
		const srcColorObj = new DpitColor(srcColor);
		colorRangeArray.forEach((color) => {
			const colorObj = new DpitColor(color);
			contrasts.push({
				color: colorObj,
				contrast: srcColorObj.contrast(colorObj)
			});
		});
		if (contrasts.length) {
			if (preferWhiteText) contrasts[0].contrast *= 3.2;
			else contrasts[0].contrast *= 1.5;
			contrasts.sort((a, b) => b.contrast - a.contrast);
			//console.log(contrasts.map((element) => element.contrast));
			if (contrasts[0].contrast < fallBackContrastThreshold) {
				const fallbackColorObj = new DpitColor(fallbackColor);
				contrasts.push({
					color: fallbackColorObj,
					contrast: srcColorObj.contrast(fallbackColorObj)
				});
				contrasts.sort((a, b) => b.contrast - a.contrast);
			}
			return contrasts[0].color;
		}
		return colorRangeArray && colorRangeArray[0]
			? new DpitColor(colorRangeArray[0])
			: new DpitColor(fallbackColor);
	}

	static getMostColor(dpitColors, rgbIdx /*r = red*, g = green, b = blue*/) {
		let res = null;
		if (!Array.isArray(dpitColors)) {
			throw new Error('Argument "mixinColor" isn\'t a DpitColor instance, but rather an instance of ' + typeof colorToMixIn);
		}
		const dpitColorsToSort = [...dpitColors];
		dpitColorsToSort.sort((a, b) => DpitColorAnalyze.compareColorsByRgbHue(rgbIdx, a, b));
		res = dpitColorsToSort[0];

		return res;
	}

	static getRgbHueFeature = (rgbIdx, color) => {
		switch (rgbIdx) {
			case 'r': return color.red() + (color.red() - color.green()) + (color.red() - color.blue());
			case 'g': return color.green() + (color.green() - color.red()) + (color.green() - color.blue());
			case 'b': return color.blue() + (color.blue() - color.red()) + (color.blue() - color.green());
		}
	};

	static getRgbHueAdjustedColor = (rgbKey, color) => {
		const addVal = 100;
		switch (rgbKey) {
			case 'r': return DpitColor.fromRgb(Math.min(color.red() + addVal, 255), Math.max(color.green() - addVal, 0), Math.max(color.blue() - addVal, 0));
			case 'g': return DpitColor.fromRgb(Math.max(color.red() - addVal, 0), Math.min(color.green() + addVal, 255), Math.max(color.blue() - addVal, 0));
			case 'b': return DpitColor.fromRgb(Math.max(color.red() - addVal, 0), Math.max(color.green() - addVal, 0), Math.min(color.blue() + addVal, 255));
		}
	};

	static compareColorsByRgbHue = (rgbKey, a, b) => {
		return DpitColorAnalyze.getRgbHueFeature(rgbKey, b) - DpitColorAnalyze.getRgbHueFeature(rgbKey, a);
	};
}